import React from "react";
import { Switch } from "react-router-dom";

import DefaultRoute from "routes/defaultRoute";

import FichaTecnica from "pages/private/cadastro/fichaTecnica";
import FichaTecnicaForm from "pages/private/cadastro/fichaTecnica/form";

const FichaTecnicaRoutes = ({ match }) => {
  const PARENT_PATH = match.url || "";
  return (
    <Switch>
      <DefaultRoute exact path={PARENT_PATH} component={FichaTecnica} />
      <DefaultRoute
        exact
        path={PARENT_PATH + "/novo"}
        component={FichaTecnicaForm}
      />
      <DefaultRoute
        exact
        path={PARENT_PATH + "/:techSheetId"}
        component={FichaTecnicaForm}
      />
      <DefaultRoute />
    </Switch>
  );
};

export default FichaTecnicaRoutes;
